import numeral from 'numeral';
import moment from 'moment';


export function formatDate(date) {
    return moment(date).format('DD/MM/YY')
}

export function formatDatetime(datetime) {
    return moment(datetime).format('DD/MM/YY HH:mm');
}

export function formatTime(datetime) {
    return moment(datetime).format('HH:mm');   
}

export function numberPadding(number, spaces = 2, char = '0') {
    var s = String(number);
    while (s.length < spaces) {s = char + s;}
    return s;
}

export function formatFloat(number) {
    return numeral(number).format('0,0.00');
}

export function formatMoney(number) {
    return numeral(number).format('$0,0.00');
}


/** WEBPACK FOOTER **
 ** ./src/utils/formatting.js
 **/